import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { EventCateringApprovalListItemDTO } from '../../../../dto/event/event-catering-approval-list-item.dto';
import { Router } from '@angular/router';
import {
  buildCateringApprovedAtColumn,
  buildCateringDualCountColumns,
  buildCateringNameLocationColumns,
  buildCateringPreferencesIconColumn,
  buildCateringTableOptions,
  buildEventScheduleColumn,
  buildEventViewIconColumn,
  CATERING_EVENT_LIST_TABLE_BASE,
  loadCateringGroupFilterOptions,
} from './duna_catering_list.shared';

export function duna_catering_approved(componentDataSourceService: ComponentDataSourceService) {
  const router = componentDataSourceService.injector.get(Router);
  const http = componentDataSourceService.http;

  const tableSettings = {
    columns: [
      buildEventScheduleColumn(),
      ...buildCateringNameLocationColumns(),
      ...buildCateringDualCountColumns(),
      buildCateringApprovedAtColumn(),
      buildCateringPreferencesIconColumn(),
      buildEventViewIconColumn(router),
    ],
    ...CATERING_EVENT_LIST_TABLE_BASE,
  };

  return {
    name: 'DUNA Catering Approved',
    description: 'Events med catering_included der er godkendt (pending antal matcher godkendt antal)',
    execute: (params?: LoadDataParams): Observable<any> => {
      return loadCateringGroupFilterOptions(http).pipe(
        switchMap((groupOptions) => {
          const mergedFilters = [...(params?.filters || [])];
          if (!mergedFilters.some(f => f.column === 'status')) {
            mergedFilters.push({ column: 'status', value: 'approved', operator: 'equals' } as any);
          }
          if (!mergedFilters.some(f => f.column === 'include_no_participants')) {
            mergedFilters.push({ column: 'include_no_participants', value: true, operator: 'equals' } as any);
          }

          const requestParams: LoadDataParams = {
            ...(params || ({ } as any)),
            dataSourceKey: 'duna_catering_approved',
            filters: mergedFilters
          };

          return componentDataSourceService['loadDataWithStandardFiltersGET'](
            'duna_catering_approved',
            '/events/catering',
            requestParams
          ).pipe(
            catchError(error => {
              console.error('Error fetching approved catering approvals:', error);
              return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
            }),
            map(result => {
              const items = (result?.items || []) as EventCateringApprovalListItemDTO[];
              return {
                items,
                totalCount: result?.totalCount ?? items.length,
                pageSize: result?.pageSize ?? 10,
                pageIndex: result?.pageIndex ?? 0,
                filters: result?.filters,
                settings: {
                  ...tableSettings,
                  tableOptions: buildCateringTableOptions(groupOptions, params)
                }
              };
            })
          );
        })
      );
    },
    settings: {
      ...tableSettings,
      tableOptions: buildCateringTableOptions([], undefined)
    }
  };
}
